import React from 'react'
import Styles from './Loading.module.css'
import Icon from '../Icon/Icon'

export default function Loading(props) {
    return (
        <div className={Styles.Loading}>
            <Icon name="spinner" className="icon-spin" />
        </div>
    )
}